import { MeasurementDimension } from '../query.types';

export const rdnsDimensions: Record<string, MeasurementDimension> = {
  rdns_src_hostname: { Label: 'rDNS Hostname', Direction: 'src', Category: 'rDNS' },
  rdns_dst_hostname: { Label: 'rDNS Hostname', Direction: 'dst', Category: 'rDNS' }
};
